export default {
  'path': '/demo/detail-container',
  'meta': {
    'name': 'demo-Container',
    'title': 'Container Container',
    'isComponentDoc': true,
    'category': 'Other'
  }
};
